define( function() {
	return ( /^$|\/(?:java|ecma)script/i );
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/manipulation/var/rscriptType.js
 ** module id = 846
 ** module chunks = 2
 **/